import { StyleSheet } from 'react-native';

export default StyleSheet.create({
  horizontalContainerStyle: {
    height: 6,
    borderRadius: 2.5,
    marginTop: 10,
  },
  verticalContainerStyle: {
    width: 6,
    borderRadius: 2.5,
    flexDirection: 'row',
    height: 105,
    alignItems: 'flex-end',
  },
  progressStyle: {
    flex: 1,
    alignItems: 'flex-end',
  },
  dividerContainer: theme => ({ backgroundColor: theme.colors.backgroundColorSeven }),
  dividerVerticalStyle: {
    alignSelf: 'stretch',
    height: 2,
  },
  dividerHorizontalStyle: {
    flex: 1,
    width: 2,
  },
  hiddenOverflow: { overflow: 'hidden' },
});
